// Size in mega bytes
export const MAXIMUM_OG_IMAGE_UPLOAD_SIZE = 5;
